// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gGrm","content":"styles_content__1NltN"};